<template>
  <div class="forum-box">
    <div class="forum-ul">
      <div class="forum-li" v-for="(item, index) in list" :key="index" @click="onClickRoute(item)">
        <div class="forum-top">
          <img v-if="item.avatar && item.avatar.url != undefined" :src="item.avatar.url" />
          <img v-else src="@/assets/images/defaultHead.png" />
          <div class="forum-user">
            <div class="user-name">{{ item.userNickName }}</div>
            <div class="time">{{ item.createTimeFormat }}</div>
          </div>
        </div>
        <div class="forum-text">{{ item.noteContent }}</div>
        <div class="forum-img" :class="{ active: item.noteImages.length > 2 }">
          <!-- <img v-for="(img, idx) in item.noteImages" :key="idx" :src="img.url" alt="img" /> -->
          <div class="forum-img-item" v-for="(img, idx) in item.noteImages" :key="idx">
            <el-image :src="img.url" :preview-src-list="showImgList(item.noteImages)" fit="contain" @click="handlePreview"></el-image>
          </div>
        </div>
        <div class="forum-bottom">
          <div class="operate-li" @click.stop="toggleFirst(item, index)">
            <img :src="item.likeStatus ? require('@/assets/images/f5.png') : require('@/assets/images/f1.png')" />
            <span>{{ item.likeCount }}</span>
          </div>
          <div class="operate-li" @click.stop="toggleThird(item, index)">
            <img :src="item.collectionStatus ? require('@/assets/images/f6.png') : require('@/assets/images/f3.png')" />
            <span>{{ item.collectCount }}</span>
          </div>
          <div class="operate-li" @click.stop="toggleShare(item, index)">
            <img src="@/assets/images/f4.png" alt="" />
            <span>{{ item.shareCount }}</span>
          </div>
          <div class="operate-li" @click.stop="showComment(item, index)">
            <img src="@/assets/images/f2.png" alt="" />
            <span>{{ item.commentCount }}</span>
          </div>
        </div>
      </div>
    </div>
    <commentInput :showCommentPop.sync="showCommentPop" :id="id" isForum="1"></commentInput>
  </div>
</template>

<script>
import commentInput from "@/components/base/commentInput"
import { setGiveALike, setCollection, shareForumPost } from '@/api/forum'
export default {
  name: 'Forum',
  components: { commentInput },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      toggleStatus: [], // 每条帖子有两个状态字段：{ first: false, third: false }
      showCommentPop: false,
      id: '',
    }
  },
  watch: {
    list: {
      handler(newVal) {
        // this.toggleStatus = newVal.map(() => ({ first: false, third: false }))
      },
      immediate: true
    }
  },
  methods: {
    showImgList(value) {
      let temporary = JSON.parse(JSON.stringify(value))
      let temporaryTwo = []
      temporary.forEach(item => {
        temporaryTwo.push(item.url)
      })
      return temporaryTwo
    },
    handlePreview(event) {
      event.stopPropagation();
    },
    onClickRoute(value) {
      this.$router.push(`/ForumCenterDetails/${value.id}`)
    },
    showComment(value, index) {
      this.showCommentPop = true
      this.id = value.id
    },
    toggleFirst(value, index) {
      setGiveALike({
        noteId: value.id,
      }).then(res => {
        if (res.code == "A00000") {
          let temporary = JSON.parse(JSON.stringify(this.list))
          temporary[index].likeStatus = !temporary[index].likeStatus
          temporary[index].likeCount = temporary[index].likeStatus ? (1 + temporary[index].likeCount) : (temporary[index].likeCount - 1)
          this.$emit('update:list', temporary)
        }
      })
    },
    toggleThird(value, index) {
      setCollection({
        noteId: value.id,
      }).then(res => {
        if (res.code == "A00000") {
          let temporary = JSON.parse(JSON.stringify(this.list))
          temporary[index].collectionStatus = !temporary[index].collectionStatus
          temporary[index].collectCount = temporary[index].collectionStatus ? (1 + temporary[index].collectCount) : (temporary[index].collectCount - 1)
          this.$emit('update:list', temporary)
        }
      })
    },
    toggleShare(value, index) {
      shareForumPost({
        noteId: value.id,
      }).then(res => {
        if (res.code == "A00000") {
          const url = `${window.location.href.split("#")[0]}#/ForumCenterDetails/${value.id}` // 获取当前页面的URL
          navigator.clipboard.writeText(url).then(() => {
            // 复制成功后的回调
            let temporary = JSON.parse(JSON.stringify(this.list))
            temporary[index].shareCount = (1 + temporary[index].shareCount)
            this.$emit('update:list', temporary)
            this.$message.success("已复制链接!")
          }).catch(err => {
            // 复制失败的处理
            console.error('复制失败:', err);
          });
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.forum-ul {
  .forum-li {
    cursor: pointer;

    .forum-bottom {
      display: flex;
      align-items: center;
      margin-top: 18px;

      .operate-li {
        cursor: pointer;
        width: 93px;
        display: flex;
        align-items: center;

        img {
          width: 14px;
          margin-right: 4px;
        }

        span {
          color: #525252;
          font-size: 12px;
        }
      }
    }

    .forum-img.active {
      img {
        height: 88px;
      }
    }

    .forum-img {
      display: flex;
      align-items: center;
      margin-top: 14px;

      .forum-img-item {
        height: 220px;
        margin-right: 12px;
        
        /deep/.el-image {
          height: 220px;
        }
      }
    }

    .forum-text {
      color: #525252;
      font-size: 14px;
      line-height: 22px;
      margin-top: 18px;
    }

    .forum-top {
      display: flex;
      align-items: center;

      .forum-user {
        .user-name {
          color: #404040;
          font-size: 14px;
          line-height: 14px;
        }

        .time {
          color: #A3A3A3;
          font-size: 12px;
          margin-top: 4px;
        }
      }

      img {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        margin-right: 6px;
        overflow: hidden;
      }
    }

    background: #fff;
    border-radius: 6px;
    margin-bottom: 10px;
    padding: 14px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ForumCenter/components/forum.vue